import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsBreadcrumbsComponent, isNotNullable, PageMetaService, TranslationService } from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CmsComponentData } from '@spartacus/storefront';
import { Location } from '@angular/common';
import { ICON_TYPE } from '../../../../../custom/icons/icon.model';

@Component({
  selector: 'cx-breadcrumb',
  templateUrl: './custom-breadcrumb-formsPageTemplate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomBreadcrumbFormsPageTemplateComponent implements OnInit {
  title$: Observable<string>;
  crumbs$: Observable<any[]>;
  iconTypes = ICON_TYPE;

  constructor(
    public component: CmsComponentData<CmsBreadcrumbsComponent>,
    protected pageMetaService: PageMetaService,
    private translation: TranslationService,
    private _location: Location,
  ) {}

  ngOnInit(): void {
    this.setTitle();
    this.setCrumbs();
  }

  private setTitle(): void {
    this.title$ = this.pageMetaService.getMeta().pipe(
      filter(isNotNullable),
      map((meta) => (meta.heading || meta.title) ?? '')
    );
  }

  private setCrumbs(): void {
    this.crumbs$ = combineLatest([
      this.pageMetaService.getMeta(),
      this.translation.translate('common.home'),
    ]).pipe(
      map(([meta, textHome]) =>
        meta?.breadcrumbs ? meta.breadcrumbs : [{ label: textHome, link: '/' }]
      )
    );
  }

  back(): void {
    this._location.back();
  }
}
